import React, { Suspense, lazy } from 'react';
import { Switch } from 'react-router-dom';

import PrivateRoute from './shared/auth/private-route';
import ErrorBoundaryRoute from './shared/error/error-boundary-route';
import PageNotFound from './shared/error/page-not-found';
import Login from './containers/Login/Login';
import { ROUTE } from './config/constants';
// import Home from './containers/Home/Home';
const Home = lazy(() => import('./containers/Home/Home'));
const OkkoPay = lazy(() => import('./containers/OkkoPay/OkkoPay'));
// import Sites from './containers/Site/Sites';
const Sites = lazy(() => import('./containers/Site/Sites'));
const Stores = lazy(() => import('./containers/Store/Stores'));
const Orders = lazy(() => import('./containers/Order/Orders'));
const BoltPim = lazy(() => import('./containers/BoltPim/BoltPim'));
const loader = (
    <div className="loader lazy">
        <i className="pi pi-spin pi-spinner" />
    </div>
);

const Routes = () => (
    // <div className="view-routes">
    <Suspense fallback={loader}>
        <Switch>
            <ErrorBoundaryRoute path={ROUTE.LOGIN} component={Login} />
            <PrivateRoute path="/" exact component={Home} />
            <PrivateRoute path={ROUTE.OKKO_PAY} component={OkkoPay} />
            <PrivateRoute path={ROUTE.SITE} component={Sites} />
            <PrivateRoute path={ROUTE.STORE} component={Stores} />
            <PrivateRoute path={ROUTE.ORDER} component={Orders} />
            <PrivateRoute path={ROUTE.BOLT_PIM} component={BoltPim} />
            <ErrorBoundaryRoute component={PageNotFound} />
        </Switch>
    </Suspense>
    // </div>
);

export default Routes;
